require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ../node_modules/angular-animate/index.js
// module id = 218
// module chunks = 0